@if (showAsIcon) {
  <div (click)="switchTheme()" style="display: contents;"  #themeSwitch>
    @if (darkActive()) {
      <mat-icon mat-list-icon [matTooltip]="'themeswitch.tolightmode'|translate">light_mode</mat-icon>
    } @else {
      <mat-icon mat-list-icon [matTooltip]="'themeswitch.todarkmode'|translate">dark_mode</mat-icon>
    }
  </div>
}